import React from "react";
import { format } from "date-fns";
import { Calendar } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { Calendar as CalendarComponent } from "../../components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "../../components/ui/popover";

export default function AddReminderDialog({ open, onOpenChange, reminderData, setReminderData, onSubmit }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#FDFBF7] border-[#E7E5E4]">
        <DialogHeader>
          <DialogTitle style={{ fontFamily: "Playfair Display, serif" }}>Add Follow Up</DialogTitle>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4 mt-4">
          <div>
            <label className="block text-sm font-medium text-[#1C1917] mb-1">Reminder Date *</label>
            <Popover>
              <PopoverTrigger asChild>
                <button type="button" className="form-input flex items-center justify-between" data-testid="reminder-date-trigger">
                  {format(reminderData.date, "PPP")}
                  <Calendar size={16} className="text-[#A8A29E]" />
                </button>
              </PopoverTrigger>
              <PopoverContent className="w-auto p-0 bg-white" align="start">
                <CalendarComponent
                  mode="single"
                  selected={reminderData.date}
                  onSelect={(date) => date && setReminderData((prev) => ({ ...prev, date }))}
                  initialFocus
                />
              </PopoverContent>
            </Popover>
          </div>
          <div>
            <label className="block text-sm font-medium text-[#1C1917] mb-1">Message *</label>
            <textarea
              value={reminderData.message}
              onChange={(e) => setReminderData((prev) => ({ ...prev, message: e.target.value }))}
              className="form-input min-h-[80px]"
              placeholder="What should be done?"
              required
              data-testid="reminder-message-input"
            />
          </div>
          <div className="flex gap-3 justify-end pt-2">
            <button type="button" onClick={() => onOpenChange(false)} className="btn-secondary">Cancel</button>
            <button type="submit" className="btn-primary" disabled={!reminderData.message} data-testid="submit-reminder">
              Add Follow Up
            </button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
